import React, { useEffect, useMemo, useState } from 'react';
import { Permissao } from '../../../../shared/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col } from 'reactstrap';
import SuggestionsAndLinksModal, { ModalViewType } from './SuggestionsAndLinksModal';
import { useTranslation } from 'react-i18next';
import { SuggestionsAndLinksButton, SuggestionsAndLinksLink } from './styles/SuggestionsAndLinksStyles';
import { MobileHeaderContainer } from './styles/MobileHeaderStyles';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCommentDots } from '@fortawesome/free-regular-svg-icons';
import { MobileButton, MobileButtonOrganizer, MobileLink } from './styles/MobileStyles';

interface SuggestionsAndLinksProps {}
const SuggestionsAndLinks: React.FC<SuggestionsAndLinksProps> = (props) => {

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalViewType, setModalViewType] = useState<ModalViewType>(null);
    const [modalTitle, setModalTitle] = useState<string|null>(null);

    const {t} = useTranslation();

    const permissions = useMemo(() => ({
        suggestions: Permissao.busca(13),
        comments: Permissao.busca(12),
        hasIcap: Permissao.tem(57),
        hasRedePergamum: Permissao.tem(87),
    }), []);


    const handleOnClickSuggestion = (viewType: ModalViewType, description: string) => {
        setModalViewType(viewType)
        setModalTitle(description)
        setModalIsOpen(true)
    }


    return (
        <div className='secaoBtnMobileLink'>
            
            <MobileButtonOrganizer>
                {
                    permissions.comments ? (
                        <MobileButton
                            className='btn-generic--segundo ml-0'
                            onClick={() => handleOnClickSuggestion('C', permissions.comments.descricao)}
                        >
                            <FontAwesomeIcon icon={['far', 'comment-dots']} className="r5" />
                            {permissions.comments.descricao}
                        </MobileButton>
                    ) : ''
                }

                {
                    permissions.suggestions ? (
                        <MobileButton
                            className='btn-generic--segundo ml-0'
                            onClick={() => handleOnClickSuggestion('S', permissions.suggestions.descricao)}
                        >
                            <FontAwesomeIcon
                                icon="shopping-bag"
                                className="r5"
                            />
                            {permissions.suggestions.descricao}
                        </MobileButton>
                    ) : ''
                }

                {permissions.hasIcap ? (
                    <MobileLink
                        rel="noopener noreferrer"
                        className='btn-generic--segundo ml-0'
                        target="_blank"
                        href="https://www.pergamum.pucpr.br/artigos_compartilhados/index.php?resolution2=1024"
                    >
                        <FontAwesomeIcon
                            icon="database"
                            className="r5"
                        />
                        Pergamum Artigos Compartilhados
                    </MobileLink>
                ) : ''}

                {permissions.hasRedePergamum ? (
                    <MobileLink
                        rel="noopener noreferrer"
                        className='btn-generic--segundo ml-0'
                        target="_blank"
                        href="https://www.pergamum.pucpr.br/redepergamum/consultas/site_CRP/pesquisa.php"
                    >
                        <FontAwesomeIcon
                            icon="database"
                            className="r5"
                        />
                        {t('CatalogoRedePergamum')}
                    </MobileLink>
                ): ''}
            </MobileButtonOrganizer>
            <SuggestionsAndLinksModal
                title={modalTitle}
                isOpen={modalIsOpen}
                setIsOpen={setModalIsOpen}
                viewType={modalViewType}
            />
        </div>
    )


    return (
        <div className="container text-center pad20 preto80">
            <SuggestionsAndLinksModal
                title={modalTitle}
                isOpen={modalIsOpen}
                setIsOpen={setModalIsOpen}
                viewType={modalViewType}
            />
            <div className="d-flex flex-column justify-content-center" style={{ gap: '8px' }}>
                {
                    permissions.comments ? (
                        <SuggestionsAndLinksButton
                            onClick={() => handleOnClickSuggestion('C', permissions.comments.descricao)}
                        >
                            <FontAwesomeIcon icon={['far', 'comment-dots']} className="r5" />
                            {permissions.comments.descricao}
                        </SuggestionsAndLinksButton>
                    ) : ''
                }

                {
                    permissions.suggestions ? (
                        <SuggestionsAndLinksButton
                            onClick={() => handleOnClickSuggestion('S', permissions.suggestions.descricao)}
                        >
                            <FontAwesomeIcon
                                icon="shopping-bag"
                                className="r5"
                            />
                            {permissions.suggestions.descricao}
                        </SuggestionsAndLinksButton>
                    ) : ''
                }

                {permissions.hasIcap ? (
                    <SuggestionsAndLinksLink
                        rel="noopener noreferrer"
                        target="_blank"
                        href="https://www.pergamum.pucpr.br/icap"
                    >
                        <FontAwesomeIcon
                            icon="database"
                            className="r5"
                        />
                        ICAP
                    </SuggestionsAndLinksLink>
                ) : ''}
                {permissions.hasRedePergamum ? (
                        <SuggestionsAndLinksLink
                            rel="noopener noreferrer"
                            target="_blank"
                            href="https://www.pergamum.pucpr.br/redepergamum/consultas/site_CRP/pesquisa.php"
                        >
                            <FontAwesomeIcon
                                icon="database"
                                className="r5"
                            />
                            {t('CatalogoRedePergamum')}
                        </SuggestionsAndLinksLink>
                ): ''}
            </div>
        </div>
    )
}

export default SuggestionsAndLinks;
